/** Expiry + stacked DTE for puts/calls screener tables (web + extension). */

import { compactSubline } from "./webCompactMode";

export interface ScreenerExpiryRow {
  expiration_date?: string | null;
  dte?: number | null;
  expires_after_earnings?: boolean;
  next_earnings_date?: string | null;
}

export function screenerExpiryDteSubline(dte: number | null | undefined): { text: string; className: string } {
  const text = dte != null ? `${dte} DTE` : "—";
  const className =
    dte === 0 ? "loss" : dte != null && dte <= 2 ? "sfe-mobile-dte-warning" : "sfe-web-compact-sub";
  return { text, className };
}

export function screenerExpiryDateLabel(expirationDate: string | null | undefined): string {
  if (!expirationDate) return "—";
  const iso = expirationDate.trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return iso ? iso[1] : expirationDate.trim() || "—";
}

export function screenerExpiryEarningsTip(rec: ScreenerExpiryRow): string {
  if (!rec.expires_after_earnings) return "";
  return `Expiration on or after next earnings date.${rec.next_earnings_date ? ` Next: ${rec.next_earnings_date}.` : ""}`;
}

export function renderScreenerExpiryInnerHtml(
  rec: ScreenerExpiryRow,
  esc: (value: string) => string = (value) => value,
): string {
  const exp = screenerExpiryDateLabel(rec.expiration_date);
  if (exp === "—") return "—";
  const sub = screenerExpiryDteSubline(rec.dte);
  return `${esc(exp)}${compactSubline(sub.text, sub.className)}`;
}

export function paintScreenerExpiryCell(cell: HTMLTableCellElement, rec: ScreenerExpiryRow | undefined): void {
  const exp = screenerExpiryDateLabel(rec?.expiration_date);
  cell.classList.add("sfe-screener-expiry-cell");
  if (exp === "—") {
    cell.removeAttribute("data-expiration-date");
    cell.textContent = "—";
    return;
  }
  cell.setAttribute("data-expiration-date", exp);
  const tip = screenerExpiryEarningsTip(rec ?? {});
  if (tip) {
    cell.setAttribute("data-tip", tip);
    cell.title = tip;
  } else {
    cell.removeAttribute("data-tip");
    cell.removeAttribute("title");
  }
  cell.innerHTML = renderScreenerExpiryInnerHtml(rec ?? {});
}
